import { render } from "./Swapper.vue?vue&type=template&id=b3c244c8&scoped=true"
import script from "./Swapper.vue?vue&type=script&lang=js"
export * from "./Swapper.vue?vue&type=script&lang=js"

import "./Swapper.vue?vue&type=style&index=0&id=b3c244c8&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c244c8"]])

export default __exports__